import { useState, useEffect } from "react";

export interface UseError {
  message: string;
  setMessage: React.Dispatch<React.SetStateAction<string>>;
  empty: () => boolean;
  clear: () => void;
}

export function useError(timeout = 12000): UseError {
  const [message, setMessage] = useState("");

  /**
   * Hide the error after the timeout.
   *
   * @remarks
   * We will automatically reset the error after `timeout` so the error doesn't remain on the customers screen.
   */
  useEffect(() => {
    if (message) {
      setTimeout(() => setMessage(""), timeout);
    }
  }, [message]);

  /**
   * Check for the presence of an error in the state.
   *
   * @remarks
   * This simple boolean function indicates whether an error has been captured.
   */
  const empty = (): boolean => {
    return !message;
  };

  /**
   * Clear the error message.
   *
   * @remarks
   * Sugar for setMessage("").
   */
  const clear = (): void => {
    setMessage("");
  };

  /**
   * Return the hook.
   */
  return {
    message,
    setMessage,
    empty,
    clear,
  };
}
